import { BagPersonalTagIcon } from './BagPersonalTagIcon';

/**
 * author: Matthew Terry
 * id 59865159-47DA-4B5F-8F5D-5E73D32BD4EA
 * name bag-personal-tag
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-tag.svg
 * tags
 */
export const PropertyTagIcon = BagPersonalTagIcon;
export default PropertyTagIcon